<app-navbar-style-one></app-navbar-style-one>

<div class="inner-banner inner-bg3">
    <div class="container">
        <div class="inner-banner-title text-center">
            <h3>{{categoryName}}</h3>
        </div>
        
        <div class="banner-list">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-7">
                    <ul class="list">
                        <li><a href="/">الرئيسية</a></li>
                        <li><i class='bx bx-chevron-right'></i></li>
                        <li class="active">{{categoryName}}</li>
                    </ul>
                </div>

                <div class="col-lg-6 col-md-5">
                    <p>نتائج البحث عن: <a class="active">{{categoryName}}</a></p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="listing-widget-section pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-4">
                <div class="listing-section-right">
                    <h3 class="title"> <i class="flaticon-filter"></i> تصفية <span style="float: left;" (click)="clearFilter()"><i class="bx bx-window-close" title="إزالة التصفية"></i></span></h3>

                    <div class="listing-right-form">
                        <form [formGroup]="filterForm" (ngSubmit)="onSubmit()">
                            <!-- <div class="form-group">
                                <i class='flaticon-filter'></i>
                                <select class="form-control">
                                    <option>All Listing Type</option>
                                    <option>Restaurants</option>
                                    <option>Events</option>
                                    <option>Hotels</option>
                                </select>	
                            </div> -->
                            <!-- <div class="form-group">
                                <i class='flaticon-loupe'></i>
                                <input type="text" class="form-control" placeholder="ما الذي تبحث عنه">
                            </div> -->
                            <!-- <div class="form-group">
                                <i class='flaticon-menu'></i>
                                <input type="text" class="form-control" placeholder="All Cities">
                            </div> -->
                            <!-- <div class="form-group">
                                <i class='flaticon-list'></i>
                                <select class="form-control">
                                    <option>All Category</option>
                                    <option>Restaurants</option>
                                    <option>Events</option>
                                    <option>Hotels</option>
                                </select>	
                            </div> -->
                            <!-- <div class="form-group">
                                <i class="flaticon-calendar"></i>
                                <input type="text" class="form-control" placeholder="Date & Time">
                            </div> -->
                        </form>
                    </div>

                    <div class="facilities-list">
                        <h3 class="facilities-title"> تصفية عن طريق</h3>

                        <ul class="clear-display-inline-block">
                            <li>
                                <div class="agree-label">
                                    <input type="radio" name="method" value="offer" id="offer" (click)="changeValue('offers')">
                                    <label for="offer">العروض</label>
                                </div>
                            </li>
                            <li>
                                <div class="agree-label">
                                    <input type="radio" name="method" value="rates" id="rate" (click)="changeValue('rates')">
                                    <label for="rate">التقييم</label>
                                </div>
                            </li>
                            <li>
                                <div class="agree-label">
                                    <input type="radio" name="method" value="price" id="price" (click)="changeValue('price')">
                                    <label for="price">السعر</label>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div class="col-lg-12 col-md-12 text-center">
                        <button type="submit" class="default-btn border-radius" (click)="onSubmit()">نتائج التصفية <i class='bx bx-plus'></i></button>
                    </div>
                </div>
            </div>

            <div class="col-lg-8">
                <div class="listing-widget-into" style="position: relative;">
                    <!-- <div class="row">
                        <div class="col-lg-9 col-sm-9">
                            <div class="listing-right-form">
                                <div class="row">
                                    <div class="form-group">
                                        <label>Sort by:</label>
                                    </div>
                                    <div class="col-lg-7 col-sm-8">
                                        <div class="form-group">
                                            <i class='flaticon-filter'></i>
                                            <select class="form-control">
                                                <option>All Listing Type</option>
                                                <option>Restaurants</option>
                                                <option>Events</option>
                                                <option>Hotels</option>
                                            </select>	
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-3 col-sm-3">
                            <ul class="listing-widget-menu">
                                <li><a routerLink="/listing" class="active"><i class="flaticon-filter"></i></a></li>
                                <li><a routerLink="/listing"><i class="flaticon-menu"></i></a></li>
                            </ul>
                        </div>
                    </div> -->
                    <div class="overlay" *ngIf="isLoading"><!--*ngIf="isLoading"-->
                        <div class="spinner-border text-secondary" role="status" style="position: absolute;z-index: 9;top: 50%;left: 50%;">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                    <div class="row" *ngIf="!isLoading">
                        <div class="col-lg-6 col-md-6" *ngFor="let product of products;let i = index">
                            <div class="place-list-item">
                                <div class="images">
                                    <a href="/listing-details/{{product.hashedId}}/{{product.name}}" class="images-list">
                                        <img src="{{product.avatar}}" alt="{{product.name}}">
                                        <!-- <p>{{product.avatar}}</p> -->
                                    </a>
                                    <div class="place-profile">
                                        <img src="{{categoryImage}}" alt="{{categoryImage}}">
                                        <h3>{{vendorName}}</h3>
                                    </div>
                                    <div class="place-status bg-dark-orange" *ngIf="product.offer != null">
                                        <a href="listing-details/{{product.hashedId}}/{{product.name}}"><h3> <span *ngIf="product.offer.type == 'percentage'">%</span> <span *ngIf="product.offer.type == 'discount'">ج.م</span>{{product.offer.value}} خصم</h3></a>
                                    </div>
                                </div>
        
                                <div class="content">
                                    <a href="listing-details/{{product.hashedId}}/{{product.name}}"><h3>{{product.name}}</h3></a> 
                                    <p><i class="bx bx-money"></i> {{product.types[0].price}} ج.م</p>
                                    <!-- <p><i class="flaticon-cursor"></i> Dorente rio, 104, 00184 Crono, Canada</p> -->
                                    <!-- <ul class="place-rating">
                                        <li><a routerLink="/">{{product.rate}}</a></li>
                                        <li>
                                            <i *ngFor="let star of [].constructor(product.rate); let j = index" class="bx bxs-star"></i>
                                            <i *ngFor="let emptyStar of [].constructor(5 - product.rate); let k = index" class="bx bxs-star icon-color"></i>
                                        </li>
                                    </ul> -->
                                </div>
                            </div>                
                        </div>

                        <!-- <div class="col-lg-6 col-md-6">
                            <div class="place-list-item">
                                <div class="images">
                                    <a href="listing-details/{{product.id}}/{{product.name}}" class="images-list"><img src="assets/img/place-list/place-list2.jpg" alt="Images"></a>
                                    
                                    <div class="place-profile">
                                        <img src="assets/img/place-list/place-profile2.png" alt="Images">
                                        <h3>By, Jaein</h3>
                                    </div>

                                    <div class="place-status bg-dark-orange">
                                        <a href="listing-details/{{product.id}}/{{product.name}}"><h3>Closed Now</h3></a>
                                    </div>

                                    <div class="place-tag">
                                        <ul>
                                            <li><a routerLink="/listing"><i class="flaticon-place"></i></a></li>
                                            <li><a routerLink="/listing"><i class="flaticon-like"></i></a></li>
                                            <li><a routerLink="/listing"><i class="flaticon-workflow"></i></a></li>
                                        </ul>
                                        <span><a href="#">$$$</a></span>
                                        <h3 class="title"> <a href="#">Beauty Shop</a></h3>
                                    </div>
                                </div>
        
                                <div class="content">
                                    <a href="listing-details/{{product.id}}/{{product.name}}"><h3>The Beauty Shop</h3></a> 
                                    <p><i class="flaticon-cursor"></i> Davisto Laterani, 104, 00184 Roma, Italy</p>
                                    <ul class="place-rating">
                                        <li><a routerLink="/listing">5.0</a></li>
                                        <li>
                                            <i class='bx bxs-star'></i>
                                            <i class='bx bxs-star'></i>
                                            <i class='bx bxs-star'></i>
                                            <i class='bx bxs-star'></i>
                                            <i class='bx bxs-star'></i>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div> -->

                        <div class="col-lg-12 text-center" *ngIf="productsLength == 10"> 
                            <a routerLink="/listing" class="default-btn border-radius">تحميل المزيد <i class='bx bx-plus'></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer-style-two></app-footer-style-two>